export default function TableContainer(theme) {
  return {
    MuiTableContainer: {
      styleOverrides: {
        root: {
          overflowX: "auto",
          overflowY: "hidden",

          "&::-webkit-scrollbar": {
            height: 5,
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: theme.palette.primary.main,
            borderRadius: 8,
          },
          "&::-webkit-scrollbar-thumb:hover": {
            backgroundColor: theme.palette.primary.mainHover,
            cursor: "ew-resize"
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor:  theme.palette.primary.greyThread,
            borderRadius: theme.shape.customBorderRadius[0],
          },
          "&::-webkit-scrollbar-button": {
            display: "none",
            width: 0,
            height: 0,
          },
        },
      },
    },
  };
}
